import {MDCTabBar} from '@material/tab-bar'
import {PaymentCalculator} from 'securities_landing_page/payment_calculator'
import {AnnualDividendsGraph} from 'securities_landing_page/annual_dividends_graph'
import {OptimizedYieldGraph} from 'securities_landing_page/optimized_yield_graph'
import {NotificationsSignupForm} from 'securities_landing_page/notifications_signup_form'
import {scroll_to_element} from 'utils/scroller'
import {Tooltips} from 'utils/tooltips'
import {User} from 'utils/user'

optimized_graph = null
annual_graph = null

prepareLandingPage = ->
  tabBar = new MDCTabBar(document.querySelector('.tab-tab-tab .mdc-tab-bar'))
  tabBar.listen 'MDCTabBar:activated', (event) -> securityTabClicked(event.detail.index)

  loadYieldsTab = ->
    tabBar.activateTab(2)
    securityTabClicked(2)
    scroll_to_element('#yields')

  moreButton = document.querySelector('.more-yields')
  moreButton.addEventListener 'click', -> loadYieldsTab()

  new PaymentCalculator()
  new NotificationsSignupForm()

  if document.location.hash == '#yields'
    loadYieldsTab()

   new Tooltips()

   updateLinksForUser()

updateLinksForUser = ->
  if User.isLoggedIn()
    el = document.querySelector('.try-premium')
    el.remove() if el
  updateLink(link) for link in document.querySelectorAll('.not-logged-in-cta')

updateLink = (link) ->
  if User.isExpired()
    link.innerText = "Renew subscription"
    link.setAttribute('href', '/payments/new')
  else if User.isFreeAccount()
    link.innerText = "Subscription required"
    link.setAttribute('href', '/begin-free-trial')

securityTabClicked = (index) ->
  tab.classList.remove('active') for tab in document.querySelectorAll('.tab-tab-tab .tab')
  document.querySelector(".tab-tab-tab .tab:nth-child(#{index+1})").classList.add 'active'
  prepareTab(index)

prepareTab = (index) ->
  renderOptimizedYieldGraph() if index is 2 and optimized_graph == null
  renderAnnualDividendsGraph() if index is 1 and annual_graph == null

renderOptimizedYieldGraph = ->
  optimized_graph = new OptimizedYieldGraph() 

renderAnnualDividendsGraph = ->
  annual_graph = new AnnualDividendsGraph()

if document.body.getAttribute('id') == 'security-landing'
  prepareLandingPage()